<div class="container">
  <mic-breadcrumb id="dealer-setup-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/setup/dealerSetup" label="{{ translationService.translate('dealerSetupText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <form [formGroup]="dealerSetupForm">
    <div class="flex items-center justify-between mt-3 mb-4">
      <h3 class="m-0" id="dealer-setup-heading">{{ translationService.translate('dealerSetupText') }}</h3>
      <button
        id="save-button"
        type="button"
        mat-flat-button
        color="primary"
        (click)="save()"
        [matTooltip]="productSaveDisabled ? translationService.translate('comingSoonText') : null"
      >
        <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
      </button>
    </div>
    <div class="p-2">
      <mic-status class="primary" style="display: flex; align-items: center">
        <mic-icon class="sm" icon="info" style="margin-right: 8px"></mic-icon>
        {{ translationService.translate('customizeDealerSetupText') }}
      </mic-status>
    </div>
    <!-- Accordion Sections -->
    <div class="mx-2">
      <mat-accordion>
        <!-- POS Interface -->
        <mat-expansion-panel [expanded]="panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('posConfigText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>
          <div class="p-2"></div>
          <mic-status class="primary" style="display: flex; align-items: center">
            <mic-icon class="sm" icon="info" style="margin-right: 8px"></mic-icon>
            {{ translationService.translate('posAutomaticTransmitText') }}
          </mic-status>
          <div class="flex items-center p-2 border-b">
            <span style="padding-right: 150px">{{ translationService.translate('enablePOSText') }}</span>
            <div>
              <mat-slide-toggle [formControlName]="'posEnable'" color="primary"></mat-slide-toggle>
              <span class="ml-2">{{ translationService.translate('yesText') }}</span>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion>
        <!-- Work Order Settings -->
        <mat-expansion-panel [expanded]="panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('workOrderSettingsText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>

          <div class="p-2">
            <!-- Date Override Limits -->
            <div class="grid grid-cols-2 gap-4">
              <mat-form-field class="w-full">
                <mat-label>{{ translationService.translate('dueDateOverrideLimitText') }}</mat-label>
                <input
                  matInput
                  type="number"
                  [formControlName]="'dueDateOverrideLimit'"
                  placeholder="{{ translationService.translate('dueDateOverrideLimitPlaceholderText') }}"
                  required
                  maxlength="3"
                  (input)="onEnforceThreeDigits($event)"
                />
                @if (dealerSetupForm.get('dueDateOverrideLimit')?.hasError('required')) {
                <mat-error>
                  {{ translationService.translate('mandatoryFieldText') }}
                </mat-error>
                }
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>{{ translationService.translate('woBackDateLimitText') }}</mat-label>
                <input
                  matInput
                  type="number"
                  [formControlName]="'woBackDtLimit'"
                  placeholder="{{ translationService.translate('woBackDateLimitPlaceholderText') }}"
                  required
                  maxlength="3"
                  (input)="onEnforceThreeDigits($event)"
                />
                @if (dealerSetupForm.get('woBackDtLimit')?.hasError('required')) {
                <mat-error>
                  {{ translationService.translate('mandatoryFieldText') }}
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Toggle Settings Grid -->
            <div class="grid grid-cols-2 mb-6 gap-6">
              <!-- Left Column -->
              <div class="space-y-4">
                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('requireWOManualReleaseText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'markWoAvailable'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('barcodeWithLeadingZeroText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'barCodeLeadingZero'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('allowEditOverrideGradeText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'overrideGradeEditable'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>
              </div>

              <!-- Right Column -->
              <div class="space-y-4">
                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('mfgDotRequiredText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'mfgDotReqOnWo'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('displayDeletedCasingsText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'displayDeleteCasing'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Work Order Optional Fields -->
      <mat-accordion>
        <mat-expansion-panel [expanded]="panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('workOrderOptionalFieldsText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>

          <div class="p-2">
            <div class="bg-blue-50 rounded mb-3">
              <mic-status class="primary" style="display: flex; align-items: center">
                <mic-icon class="sm" icon="info" style="margin-right: 8px"></mic-icon>
                {{ translationService.translate('configureCustomText') }}
              </mic-status>
            </div>

            <!-- Optional Fields Grid -->
            <div class="grid grid-cols-4 gap-4">
              <!-- Row 1 -->
              <mat-form-field>
                <mat-label>Date 1</mat-label>
                <mat-select [formControlName]="'optDate1'" placeholder="Please select an option">
                  @for (option of displayOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Label</mat-label>
                <input matInput [formControlName]="'optDate1Lable'" placeholder="Enter Label" />
              </mat-form-field>

              <!-- Row 2 -->
              <mat-form-field>
                <mat-label>Date 2</mat-label>
                <mat-select [formControlName]="'optDate2'" placeholder="Please select an option">
                  @for (option of displayOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Label</mat-label>
                <input matInput [formControlName]="'optDate2Lable'" placeholder="Enter Label" />
              </mat-form-field>

              <!-- Row 3 -->
              <mat-form-field>
                <mat-label>Free text 1</mat-label>
                <mat-select [formControlName]="'optText1'" placeholder="Please select an option">
                  @for (option of displayOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Label</mat-label>
                <input matInput [formControlName]="'optText1Label'" placeholder="Enter Label" />
              </mat-form-field>

              <!-- Row 4 -->
              <mat-form-field>
                <mat-label>Free text 2</mat-label>
                <mat-select [formControlName]="'optText2'" placeholder="Please select an option">
                  @for (option of displayOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Label</mat-label>
                <input matInput [formControlName]="'optText2Label'" placeholder="Enter Label" />
              </mat-form-field>

              <!-- Row 5 -->
              <mat-form-field>
                <mat-label>Table Lookup</mat-label>
                <mat-select [formControlName]="'optTableLookup'" placeholder="Please select an option">
                  @for (option of displayOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Shipping Settings -->
      <mat-accordion>
        <mat-expansion-panel [expanded]="panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('shippingSettingsText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>

          <div class="p-2">
            <!-- Automatic Ship List Toggle -->
            <div class="grid grid-cols-2 mb-4 gap-6">
              <div class="space-y-4">
                <div class="flex items-center justify-between border-b">
                  <span>{{ translationService.translate('automaticShipListNumberingText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'autoShipListNumbering'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>
              </div>

              <div class="space-y-4">
                <div></div>
                <!-- occupies this cell via row-span -->
                <div></div>
              </div>
            </div>

            <!-- Format Fields -->
            <div class="grid grid-cols-2 gap-4">
              <mat-form-field class="w-full">
                <mat-label>{{ translationService.translate('formatForPlantsText') }}</mat-label>
                <input matInput [formControlName]="'autoNumberingPlantFormat'" />
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>{{ translationService.translate('formatForSitesText') }}</mat-label>
                <input matInput [formControlName]="'autoNumberingSiteFormat'" />
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Password Settings -->
      <mat-accordion>
        <mat-expansion-panel [expanded]="panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('passwordSettingsText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>

          <div class="p-2">
            <div class="grid grid-cols-2 gap-4">
              <mat-form-field class="w-full">
                <mat-label>{{ translationService.translate('passwordExpireEveryDaysText') }}</mat-label>
                <input
                  matInput
                  type="number"
                  [formControlName]="'pwdExpireEvery'"
                  required
                  maxlength="3"
                  (input)="onEnforceThreeDigits($event)"
                />
                @if (dealerSetupForm.get('pwdExpireEvery')?.hasError('required')) {
                <mat-error>
                  {{ translationService.translate('mandatoryFieldText') }}
                </mat-error>
                }
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>{{ translationService.translate('minimumPasswordLengthText') }}</mat-label>
                <input
                  matInput
                  type="number"
                  required
                  maxlength="2"
                  [formControlName]="'minPwdLength'"
                  (input)="onEnforceThreeDigits($event)"
                />
                @if (dealerSetupForm.get('minPwdLength')?.hasError('minPwdLength')) {
                <mat-error>
                  {{ dealerSetupForm.get('minPwdLength')?.getError('minPwdLength') }}
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- BTM App Settings -->
      <mat-accordion>
        <mat-expansion-panel [expanded]="panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('btmAppSettingsText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>

          <div class="p-2">
            <!-- BTM Toggle Settings -->
            <div class="grid grid-cols-2 mb-6 gap-6">
              <!-- Left Column -->
              <div class="space-y-4">
                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('allowBulkEntryText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'btmAllowBulkEntry'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('allowPickupChangeText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'btmAllowPickupChange'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('canModifyDueDateText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'btmAllowModifyDueDate'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>
              </div>

              <!-- Right Column -->
              <div class="space-y-4">
                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('autoGenerateWorkOrderNumberText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'btmAutoGenerateWo'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('autoGeneratePackListNumberText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'btmAutoGeneratePlNum'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between p-2 border-b">
                  <span>{{ translationService.translate('canCreateWorkOrderText') }}</span>
                  <div class="flex items-center">
                    <mat-slide-toggle [formControlName]="'btmAllowCreateWo'" color="primary"></mat-slide-toggle>
                    <span class="ml-2">{{ translationService.translate('yesText') }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Process Codes Section -->
            <div class="mt-2">
              <h4 class="text-lg font-Bold mb-3">
                <strong>{{ translationService.translate('processCodesText') }}</strong>
              </h4>
              <div class="bg-blue-50 rounded mb-3">
                <mic-status class="primary" style="display: flex; align-items: center">
                  <mic-icon class="sm" icon="info" style="margin-right: 8px"></mic-icon>
                  {{ translationService.translate('selectAllProcessCodesBTMText') }}
                </mic-status>
              </div>

              <div class="grid grid-cols-3 gap-4">
                @for (code of processCodes; track code.code) {
                <div class="flex items-center">
                  <mat-checkbox [checked]="code.checked" (change)="onProcessCodeChanged(code, $event.checked)" color="primary">
                    {{ code.code }} - {{ code.description }}
                  </mat-checkbox>
                </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Transfer Plant Settings -->
      <div class="mt-2">
        @if (isPlantTransferPossible) {
        <mat-accordion>
          <mat-expansion-panel [expanded]="panelOpenState">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mic-icon class="mr-2" icon="folder"></mic-icon>
                {{ translationService.translate('transferPlantText') }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-divider></mat-divider>

            <div class="button-container">
              <button id="Add-button" mat-flat-button style="margin-right: 25px" color="primary" (click)="addPlantTransferRow()">
                <mic-icon class="sm" icon="add" fontSet="filled"></mic-icon> {{ translationService.translate('addText') }}
              </button>
              <button id="plant-save-button" type="button" mat-flat-button color="accent" (click)="savePlantTransfer()">
                <mic-icon class="sm" icon="save" fontSet="filled"></mic-icon> {{ translationService.translate('saveLinkText') }}
              </button>
            </div>

            <div id="plant-transfer-table" class="cam-table mt-2">
              <div style="min-width: 1400px; width: 100%; overflow-x: auto">
                <mic-table #plantTransferTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
                  <ng-container *micCellTemplate="let item; name: 'originPlantName'">
                    <div class="centered-cell">
                      <mic-dropdown-search
                        micDropdownAccessibility
                        class="wide-dropdown"
                        emptyPlaceholder="No data found"
                        [data]="getPlantList()"
                        [widthConfig]="{ width: '100%' }"
                        [formControl]="getControl(item, 'originPlantName')"
                        data-field="originPlantName"
                        appearance="outline"
                        label="{{ translationService.translate('sourcePlantText') }}"
                      >
                      </mic-dropdown-search>
                    </div>
                  </ng-container>

                  <ng-container *micCellTemplate="let item; name: 'destPlantName'">
                    <div class="centered-cell">
                      <mic-dropdown-search
                        micDropdownAccessibility
                        class="wide-dropdown"
                        emptyPlaceholder="No data found"
                        [data]="getPlantList()"
                        [formControl]="getControl(item, 'destPlantName')"
                        data-field="destPlantName"
                        appearance="outline"
                        [widthConfig]="{ width: '100%' }"
                        label="{{ translationService.translate('destinationPlantText') }}"
                      >
                      </mic-dropdown-search>
                    </div>
                  </ng-container>

                  <ng-container *micCellTemplate="let item; name: 'bothWay'">
                    <mat-checkbox [checked]="item.bothWay === 'Y'" (change)="onBothWayChanged(item, $event.checked)"> </mat-checkbox>
                  </ng-container>

                  <ng-container *micCellTemplate="let item; name: 'action'">
                    <button mat-icon-button (click)="showDeleteModal(item)" [attr.aria-label]="translationService.translate('deleteText')">
                      <mic-icon class="m" icon="delete" fontSet="filled"></mic-icon>
                    </button>
                  </ng-container>
                </mic-table>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        }
      </div>
    </div>
  </form>
  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>Are you sure you want to delete the Plant Transfer?</ng-template>
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>
    <div class="discard-message">
      {{ discardMessage || translationService.translate('discardChangesText') }}
    </div>
  </ng-template>
</div>
